import moment from 'moment'

export const urlParamsPath = (path, notIncludeUser) => `${path}/:organisation/:form${notIncludeUser ? '' : '/:user'}`

export const formatURLParam = (param, noEncode) =>
  Object.keys(param)
    .reduce((a, k) => {
      if (param[k] !== undefined && param[k] !== null && param[k] !== '') {
        if (noEncode) {
          a.push(`${k}=${param[k]}`)
          return a
        }
        a.push(`${encodeURIComponent(k)}=${encodeURIComponent(param[k])}`)
      }
      return a
    }, [])
    .join('&')

export const getSubdomain = () => {
  const subdomain = /.*?([^.]+)/.exec(window.location.host)[1]
  return subdomain
}

export const getSubdomainInHash = () => window.location.hash.split('/')[3]

export const getEventRegoFormURL = () => {
  if (window.location.hash.includes('event/landing-page') && getSubdomainInHash()) {
    // New event rego form URL
    return `${window.location.origin}/#/event/registration-form/${getSubdomainInHash()}/`
    // eslint-disable-next-line no-else-return
  } else {
    // keeping the old one to work
    return `${window.location.origin}/#/registration-form/`
  }
}

export const generateRandomString = (length = 8) => {
  const arr = []
  for (let i = 0; i < length; i += 1) {
    // eslint-disable-next-line no-bitwise
    arr.push(((Math.random() * 36) | 0).toString(36))
  }
  return arr.join('')
}

export const buildPath = (formType, path, history, urlParams) => {
  if (formType === 'membership') {
    if (urlParams) {
      return `${path}?formId=${urlParams.formId}&orgId=${urlParams.orgId}`
    }
    return `${path}${history.location.search}`
  }
  return path
}

export const toDateOnly = value => (value ? moment(value).format('YYYY-MM-DD') : value)

export function getClientTime() {
  // TEMPORARILY DISABLING CALL TO WORLDTIME API AS IT'S CURRENTLY HANGING (Thu 16 Jan 2025)
  // TODO: Refactor this code to include a timeout or provide an alternative solution

  // try {
  //   return await fetch('https://worldtimeapi.org/api/ip').then((response) => response.json())
  // } catch (err) {
  //   // Handle errror in case worldtimeapi fails to return value.
  //   return {
  //     utc_datetime: moment(),
  //   }
  // }

  return {
    utc_datetime: moment(),
  }
}

// Additional utility functions for tests
export const buildFormPath = (...segments) => {
  return segments.filter(segment => segment !== undefined && segment !== null).join('/')
}

export const debounce = (func, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func.apply(null, args), delay)
  }
}

export const deepClone = obj => {
  if (obj === null || typeof obj !== 'object') return obj
  if (obj instanceof Date) return new Date(obj.getTime())
  // biome-ignore lint/suspicious/useIsArray: TODO
  if (obj instanceof Array) return obj.map(item => deepClone(item))
  if (typeof obj === 'object') {
    const clonedObj = {}
    for (const key in obj) {
      if (Object.hasOwn(obj, key)) {
        clonedObj[key] = deepClone(obj[key])
      }
    }
    return clonedObj
  }
}

export const isEmpty = value => {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return value.length === 0
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return false
}

export const isValidDate = date => {
  if (!date) return false
  const d = new Date(date)
  // biome-ignore lint/suspicious/noGlobalIsNan: TODO
  return d instanceof Date && !isNaN(d)
}

export const convertFormType = (formType = '') => {
  switch (formType.toLowerCase()) {
    case 'registration form':
    case 'membership':
      return 'membership'

    case 'event':
    case 'event form':
    case 'event entry':
      return 'event'

    case 'shop':
    case 'shop form':
    case 'addon':
    case 'add-on':
      return 'shop'
  }
}
